export default __webpack_public_path__ + "static/media/logo_sura.0c078ede.svg";